module.exports = __webpack_public_path__ + "img/BASEBALL CAP RED.8915d23.svg";